export default "__VITE_ASSET__DbCVA2Go__"